import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-orange-500 rounded-xl p-3 md:p-4 text-white shadow-soft overflow-hidden min-w-0"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-2 mb-2\"><div class=\"w-8 h-8 bg-orange-400 rounded-lg flex items-center justify-center\"><svg class=\"w-5 h-5\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z\"></path></svg></div><span class=\"text-sm font-medium opacity-90\">Leaf Collection</span></div>", 1)
const _hoisted_3 = { class: "text-xl font-bold" }
const _hoisted_4 = { class: "text-sm opacity-80" }
const _hoisted_5 = { class: "bg-white rounded-xl max-w-lg w-full max-h-[80vh] overflow-y-auto shadow-xl" }
const _hoisted_6 = { class: "p-6" }
const _hoisted_7 = { class: "flex items-center justify-between mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-heading font-semibold text-primary-800" }, " Fall Leaf Collection ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-4 text-primary-600" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800 mb-1" }, " Foxwood Crossing Schedule (District 3) "),
    /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside space-y-1" }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("strong", null, "1st Pickup:"),
        /*#__PURE__*/_createTextVNode(" Week of October 19")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("strong", null, "2nd Pickup:"),
        /*#__PURE__*/_createTextVNode(" Week of November 2")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("strong", null, "3rd Pickup:"),
        /*#__PURE__*/_createTextVNode(" Week of November 16")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-orange-50 p-3 rounded-lg border border-orange-200" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-orange-800 mb-1" }, " Important Reminders "),
    /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside space-y-1 text-orange-700" }, [
      /*#__PURE__*/_createElementVNode("li", null, "Rake leaves to terrace (between sidewalk & curb)"),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode("Must be out by "),
        /*#__PURE__*/_createElementVNode("strong", null, "7:00 AM Monday")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, "No leaves out before October 12"),
      /*#__PURE__*/_createElementVNode("li", null, "No leaves out after November 16")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800 mb-1" }, " What's NOT Allowed "),
    /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside space-y-1" }, [
      /*#__PURE__*/_createElementVNode("li", null, "Mixing with branches, stones, or grass"),
      /*#__PURE__*/_createElementVNode("li", null, "Blocking parked cars or catch basins"),
      /*#__PURE__*/_createElementVNode("li", null, "Placing in ditches or driving lanes"),
      /*#__PURE__*/_createElementVNode("li", null, "Leaving in alleys or medians")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800 mb-1" }, " Drop-Off Option "),
    /*#__PURE__*/_createElementVNode("p", null, "Division of Public Works - 4551 S. 52nd Street"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, " Leaves must be in biodegradable paper bags or emptied from containers. LEAVES ONLY. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800 mb-1" }, "Free Mulch"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, " Free wood mulch and composted leaves available for self-serve pickup at DPW yard (4551 S. 52nd St) and west yard (11701 W. Morgan Ave). ")
  ])
], -1)

import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const showInfo = ref(false);

// Foxwood Crossing is in Aldermanic District 3
// 2026 Leaf Collection Schedule:
// 1st Pickup: Week of Oct 19
// 2nd Pickup: Week of Nov 2
// 3rd Pickup: Week of Nov 16

const LEAF_PICKUP_DATES = [
  new Date("2026-10-19"), // 1st pickup
  new Date("2026-11-02"), // 2nd pickup
  new Date("2026-11-16"), // 3rd pickup (final)
];

const isInSeason = computed(() => {
  const today = new Date();
  const seasonStart = new Date("2026-10-12"); // No leaves before this
  const seasonEnd = new Date("2026-11-22"); // Week after final pickup

  return today >= seasonStart && today <= seasonEnd;
});

const getNextPickup = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  for (const date of LEAF_PICKUP_DATES) {
    // Include the whole week (Monday through Sunday)
    const weekEnd = new Date(date);
    weekEnd.setDate(weekEnd.getDate() + 6);

    if (today <= weekEnd) {
      return date;
    }
  }
  return null;
};

const nextPickupText = computed(() => {
  const nextPickup = getNextPickup();
  if (!nextPickup) {
    return "Season Complete";
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const pickupMonday = new Date(nextPickup);
  const daysUntil = Math.ceil(
    (pickupMonday.getTime() - today.getTime()) / (24 * 60 * 60 * 1000)
  );

  if (daysUntil < 0) {
    return "This Week";
  } else if (daysUntil === 0) {
    return "Today";
  } else if (daysUntil <= 7) {
    return "This Week";
  } else if (daysUntil <= 14) {
    return "Next Week";
  } else {
    const month = pickupMonday.toLocaleString("default", { month: "short" });
    const day = pickupMonday.getDate();
    return `Week of ${month} ${day}`;
  }
});

const pickupDetails = computed(() => {
  const nextPickup = getNextPickup();
  if (!nextPickup) {
    return "Thanks for participating!";
  }

  const pickupIndex = LEAF_PICKUP_DATES.findIndex(
    (d) => d.getTime() === nextPickup.getTime()
  );

  const ordinal = ["1st", "2nd", "3rd (Final)"][pickupIndex] || "";

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const pickupMonday = new Date(nextPickup);
  const daysUntil = Math.ceil(
    (pickupMonday.getTime() - today.getTime()) / (24 * 60 * 60 * 1000)
  );

  if (daysUntil <= 0) {
    return `${ordinal} pickup - rake to curb by 7am Mon`;
  } else if (daysUntil <= 7) {
    return `${ordinal} pickup week`;
  } else {
    return `${ordinal} pickup`;
  }
});

return (_ctx: any,_cache: any) => {
  return (_unref(isInSeason))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(nextPickupText)), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(pickupDetails)), 1),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showInfo.value = true)),
          class: "mt-2 text-xs underline opacity-80 hover:opacity-100 transition-opacity"
        }, " View schedule → "),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          (showInfo.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showInfo.value = false), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (showInfo.value = false)),
                        class: "p-2 text-primary-400 hover:text-primary-600 transition-colors"
                      }, _hoisted_10)
                    ]),
                    _hoisted_11
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      ]))
    : _createCommentVNode("", true)
}
}

})